module.exports = __webpack_public_path__ + "assets/img/bg.48e56216.png";